// extracted by mini-css-extract-plugin
export default {"root":"_28vtl","content":"_2Br9p"};